import { css } from 'react-emotion'

const styles = {
  component: css({
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center'
  }),

  jumpSpanSelection: css({
    marginLeft: '10px',
    fontSize: '13px',
    color: '#808080',
    whiteSpace: 'nowrap'
  })
}
export default styles



// WEBPACK FOOTER //
// ./src/Components/VideoPlayer/JumpFrame/JumpFrameStyles.js